import { Main } from './components';

const PackingStations = () => <Main />;

export default PackingStations;
